export default __webpack_public_path__ + "4e47f3e.png";